/**
 * Which social platforms are switched on (UI .env, read at build time - rebuild after changing).
 *
 *   REACT_APP_FACEBOOK_ENABLED=Yes   Facebook on   (default: off -> "Coming soon")
 *   REACT_APP_TWITTER_ENABLED=No     X/Twitter off (default: on)
 *
 * A platform that is off shows "Coming soon": it can not be connected or selected.
 * LinkedIn and YouTube are always on.
 */
const flag = (value: string | undefined, fallback: boolean): boolean => {
  const v = String(value ?? "").trim().toLowerCase();
  if (!v) return fallback;
  return ["yes", "true", "1", "on"].includes(v);
};

export const FACEBOOK_ENABLED = flag(process.env.REACT_APP_FACEBOOK_ENABLED, false);
export const TWITTER_ENABLED = flag(process.env.REACT_APP_TWITTER_ENABLED, true);

export const COMING_SOON_PLATFORMS: string[] = [
  ...(FACEBOOK_ENABLED ? [] : ["facebook"]),
  ...(TWITTER_ENABLED ? [] : ["twitter"]),
];

export const isComingSoonPlatform = (id: string): boolean =>
  COMING_SOON_PLATFORMS.includes(String(id || "").toLowerCase());
